import React from 'react';
import { Link } from 'react-router-dom';

export default function Modal() {
    return (
        <>
            <div className='container-fluid'>
                <div className='col-12'>
                    <nav aria-label='breadcrumb'>
                        <h2 className='mb-3'>مودال ها</h2>

                        <ol className='breadcrumb'>
                            <li className='breadcrumb-item'>
                                <Link to='/'>کامپوننت ها</Link>
                            </li>

                            <li className='breadcrumb-item'>
                                <Link to='/modal'>مودال ها</Link>
                            </li>

                            <li
                                className='breadcrumb-item active'
                                aria-current='page'
                            >
                                شما اینجایی
                            </li>
                        </ol>
                    </nav>
                </div>

                <div className='space-20' />

                <div className='row'>
                    <div className='col-sm-12 col-md-6 col-lg-3 mb-4'>
                        <div className='card'>
                            <div className='card-title bg-transparent p-3'>
                                مودال معمولی
                            </div>

                            <div className='card-body m-auto'>
                                <button
                                    type='button'
                                    className='btn btn-primary'
                                    data-bs-toggle='modal'
                                    data-bs-target='#simpleModal'
                                >
                                    امتحان کن
                                </button>

                                <div
                                    className='modal fade'
                                    id='simpleModal'
                                    tabIndex='-1'
                                    aria-labelledby='simpleModalLabel'
                                    aria-hidden='true'
                                >
                                    <div className='modal-dialog'>
                                        <div className='modal-content'>
                                            <div className='modal-header'>
                                                <h5
                                                    className='modal-title'
                                                    id='simpleModalLabel'
                                                >
                                                    عنوان مودال
                                                </h5>
                                                <button
                                                    type='button'
                                                    className='btn-close'
                                                    data-bs-dismiss='modal'
                                                    aria-label='Close'
                                                />
                                            </div>
                                            <div className='modal-body'>
                                                هورا!!! شما یک مودال باز کردی
                                            </div>
                                            <div className='modal-footer'>
                                                <button
                                                    type='button'
                                                    className='btn btn-dark'
                                                    data-bs-dismiss='modal'
                                                >
                                                    بستن
                                                </button>
                                                <button
                                                    type='button'
                                                    className='btn btn-primary'
                                                    data-bs-dismiss='modal'
                                                >
                                                    ذخیره تغییرات
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-sm-12 col-md-6 col-lg-3 mb-4'>
                        <div className='card'>
                            <div className='card-title bg-transparent p-3'>
                                مودال استاتیک
                            </div>

                            <div className='card-body m-auto'>
                                <button
                                    type='button'
                                    className='btn btn-primary'
                                    data-bs-toggle='modal'
                                    data-bs-target='#staticBackdrop'
                                >
                                    امتحان کن
                                </button>

                                <div
                                    className='modal fade'
                                    id='staticBackdrop'
                                    data-bs-backdrop='static'
                                    data-bs-keyboard='false'
                                    tabIndex='-1'
                                    aria-labelledby='staticBackdropLabel'
                                    aria-hidden='true'
                                >
                                    <div className='modal-dialog'>
                                        <div className='modal-content'>
                                            <div className='modal-header'>
                                                <h5
                                                    className='modal-title'
                                                    id='staticBackdropLabel'
                                                >
                                                    عنوان مودال
                                                </h5>
                                            </div>
                                            <div className='modal-body'>
                                                تا دکمه بستن رو نزنی من بسته
                                                نمیشم!
                                            </div>
                                            <div className='modal-footer'>
                                                <button
                                                    type='button'
                                                    className='btn btn-dark'
                                                    data-bs-dismiss='modal'
                                                >
                                                    بستن
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-sm-12 col-md-6 col-lg-3 mb-4'>
                        <div className='card'>
                            <div className='card-title bg-transparent p-3'>
                                مودال اسکرولی
                            </div>

                            <div className='card-body m-auto'>
                                <button
                                    type='button'
                                    className='btn btn-primary'
                                    data-bs-toggle='modal'
                                    data-bs-target='#scrollModal'
                                >
                                    امتحان کن
                                </button>

                                <div
                                    className='modal fade'
                                    id='scrollModal'
                                    tabIndex='-1'
                                    aria-labelledby='scrollModalLabel'
                                    aria-hidden='true'
                                >
                                    <div className='modal-dialog modal-dialog-scrollable'>
                                        <div className='modal-content'>
                                            <div className='modal-header'>
                                                <h5
                                                    className='modal-title'
                                                    id='scrollModalLabel'
                                                >
                                                    عنوان مودال
                                                </h5>
                                                <button
                                                    type='button'
                                                    className='btn-close'
                                                    data-bs-dismiss='modal'
                                                    aria-label='Close'
                                                />
                                            </div>
                                            <div className='modal-body'>
                                                <div className='space-200' />
                                                <div className='space-200' />
                                                <div className='space-200' />
                                                <div className='space-200' />
                                                <div className='space-200' />
                                                این یک مودال اسکرولی است.
                                            </div>
                                            <div className='modal-footer'>
                                                <button
                                                    type='button'
                                                    className='btn btn-dark'
                                                    data-bs-dismiss='modal'
                                                >
                                                    بستن
                                                </button>
                                                <button
                                                    type='button'
                                                    className='btn btn-primary'
                                                    data-bs-dismiss='modal'
                                                >
                                                    ذخیره تغییرات
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-sm-12 col-md-6 col-lg-3 mb-4'>
                        <div className='card'>
                            <div className='card-title bg-transparent p-3'>
                                مودال چند مرحله
                            </div>

                            <div className='card-body m-auto'>
                                <button
                                    className='btn btn-primary'
                                    data-bs-toggle='modal'
                                    data-bs-target='#exampleModalToggle'
                                    type='button'
                                >
                                    امتحان کن
                                </button>

                                <div
                                    className='modal fade'
                                    id='exampleModalToggle'
                                    aria-hidden='true'
                                    aria-labelledby='exampleModalToggleLabel'
                                    tabIndex='-1'
                                >
                                    <div className='modal-dialog modal-dialog-centered'>
                                        <div className='modal-content'>
                                            <div className='modal-header'>
                                                <h5
                                                    className='modal-title'
                                                    id='exampleModalToggleLabel'
                                                >
                                                    مودال اول
                                                </h5>
                                                <button
                                                    type='button'
                                                    className='btn-close'
                                                    data-bs-dismiss='modal'
                                                    aria-label='Close'
                                                />
                                            </div>
                                            <div className='modal-body'>
                                                با کلیک بر روی دکمه پایین به
                                                مودال دوم می روید.
                                            </div>
                                            <div className='modal-footer'>
                                                <button
                                                    className='btn btn-primary'
                                                    data-bs-target='#exampleModalToggle2'
                                                    data-bs-toggle='modal'
                                                    data-bs-dismiss='modal'
                                                >
                                                    مودال دومی
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className='modal fade'
                                    id='exampleModalToggle2'
                                    aria-hidden='true'
                                    aria-labelledby='exampleModalToggleLabel2'
                                    tabIndex='-1'
                                >
                                    <div className='modal-dialog modal-dialog-centered'>
                                        <div className='modal-content'>
                                            <div className='modal-header'>
                                                <h5
                                                    className='modal-title'
                                                    id='exampleModalToggleLabel2'
                                                >
                                                    مودال دوم
                                                </h5>
                                                <button
                                                    type='button'
                                                    className='btn-close'
                                                    data-bs-dismiss='modal'
                                                    aria-label='Close'
                                                />
                                            </div>
                                            <div className='modal-body'>
                                                این مودال دوم است. این بود مودال
                                                چند مرحله ای. با کلیک بر روی
                                                دکمه پایین به مودال اول باز
                                                میگردید.
                                            </div>
                                            <div className='modal-footer'>
                                                <button
                                                    className='btn btn-primary'
                                                    data-bs-target='#exampleModalToggle'
                                                    data-bs-toggle='modal'
                                                    data-bs-dismiss='modal'
                                                >
                                                    بازگشت به اولی
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-sm-12 col-md-6 col-lg-3 mb-4'>
                        <div className='card'>
                            <div className='card-title bg-transparent p-3'>
                                مودال فرستادن ایمیل
                            </div>

                            <div className='card-body m-auto'>
                                <button
                                    type='button'
                                    className='btn btn-primary'
                                    data-bs-toggle='modal'
                                    data-bs-target='#emailModal'
                                    data-bs-whatever='iam@amirreza.dev'
                                >
                                    امتحان کن
                                </button>

                                <div
                                    className='modal fade'
                                    id='emailModal'
                                    tabIndex='-1'
                                    aria-labelledby='emailModalLabel'
                                    aria-hidden='true'
                                >
                                    <div className='modal-dialog'>
                                        <div className='modal-content'>
                                            <div className='modal-header'>
                                                <h5
                                                    className='modal-title'
                                                    id='emailModalLabel'
                                                >
                                                    ارسال پیام جدید به
                                                    iam@amirreza.dev
                                                </h5>
                                                <button
                                                    type='button'
                                                    className='btn-close'
                                                    data-bs-dismiss='modal'
                                                    aria-label='Close'
                                                />
                                            </div>
                                            <div className='modal-body'>
                                                <form>
                                                    <div className='mb-3'>
                                                        <label
                                                            for='recipient-name'
                                                            className='col-form-label'
                                                        >
                                                            گیرنده :
                                                        </label>
                                                        <input
                                                            type='text'
                                                            className='form-control'
                                                            id='recipient-name'
                                                        />
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label
                                                            for='message-text'
                                                            className='col-form-label'
                                                        >
                                                            پیام شما :
                                                        </label>
                                                        <textarea
                                                            className='form-control'
                                                            id='message-text'
                                                        />
                                                    </div>
                                                </form>
                                            </div>
                                            <div className='modal-footer'>
                                                <button
                                                    type='button'
                                                    className='btn btn-danger'
                                                    data-bs-dismiss='modal'
                                                >
                                                    کنسل
                                                </button>

                                                <button
                                                    type='button'
                                                    className='btn btn-primary'
                                                    data-bs-dismiss='modal'
                                                >
                                                    ارسال پیام
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-sm-12 col-md-6 col-lg-3 mb-4'>
                        <div className='card'>
                            <div className='card-title bg-transparent p-3'>
                                مودال کوچیک
                            </div>

                            <div className='card-body m-auto'>
                                <button
                                    type='button'
                                    className='btn btn-primary'
                                    data-bs-toggle='modal'
                                    data-bs-target='#smallModal'
                                >
                                    امتحان کن
                                </button>

                                <div
                                    className='modal fade'
                                    id='smallModal'
                                    tabIndex='-1'
                                    aria-labelledby='smallModalLabel'
                                    aria-hidden='true'
                                >
                                    <div className='modal-dialog modal-sm'>
                                        <div className='modal-content'>
                                            <div className='modal-header'>
                                                <h5
                                                    className='modal-title'
                                                    id='smallModalLabel'
                                                >
                                                    مودال کوچیک
                                                </h5>
                                                <button
                                                    type='button'
                                                    className='btn-close'
                                                    data-bs-dismiss='modal'
                                                    aria-label='Close'
                                                />
                                            </div>
                                            <div className='modal-body'>
                                                لورم ایپسوم متن ساختگی با تولید
                                                سادگی نامفهوم از صنعت چاپ، و با
                                                استفاده از طراحان گرافیک است،
                                                چاپگرها و متون بلکه روزنامه و
                                                مجله در ستون و سطرآنچنان که لازم
                                                است، و برای شرایط فعلی تکنولوژی
                                                مورد نیاز، و کاربردهای متنوع با
                                                هدف بهبود ابزارهای کاربردی می
                                                باشد، کتابهای زیادی در شصت و سه
                                                درصد گذشته حال و آینده، شناخت
                                                فراوان جامعه و متخصصان را می
                                                طلبد.
                                            </div>
                                            <div className='modal-footer'>
                                                <button
                                                    type='button'
                                                    className='btn btn-dark'
                                                    data-bs-dismiss='modal'
                                                >
                                                    بستن
                                                </button>
                                                <button
                                                    type='button'
                                                    className='btn btn-primary'
                                                    data-bs-dismiss='modal'
                                                >
                                                    ذخیره تغییرات
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-sm-12 col-md-6 col-lg-3 mb-4'>
                        <div className='card'>
                            <div className='card-title bg-transparent p-3'>
                                مودال بزرگ
                            </div>

                            <div className='card-body m-auto'>
                                <button
                                    type='button'
                                    className='btn btn-primary'
                                    data-bs-toggle='modal'
                                    data-bs-target='#largeModal'
                                >
                                    امتحان کن
                                </button>

                                <div
                                    className='modal fade'
                                    id='largeModal'
                                    tabIndex='-1'
                                    aria-labelledby='largeModalLabel'
                                    aria-hidden='true'
                                >
                                    <div className='modal-dialog modal-lg'>
                                        <div className='modal-content'>
                                            <div className='modal-header'>
                                                <h5
                                                    className='modal-title'
                                                    id='largeModalLabel'
                                                >
                                                    مودال بزرگ
                                                </h5>
                                                <button
                                                    type='button'
                                                    className='btn-close'
                                                    data-bs-dismiss='modal'
                                                    aria-label='Close'
                                                />
                                            </div>
                                            <div className='modal-body'>
                                                لورم ایپسوم متن ساختگی با تولید
                                                سادگی نامفهوم از صنعت چاپ، و با
                                                استفاده از طراحان گرافیک است،
                                                چاپگرها و متون بلکه روزنامه و
                                                مجله در ستون و سطرآنچنان که لازم
                                                است، و برای شرایط فعلی تکنولوژی
                                                مورد نیاز، و کاربردهای متنوع با
                                                هدف بهبود ابزارهای کاربردی می
                                                باشد، کتابهای زیادی در شصت و سه
                                                درصد گذشته حال و آینده، شناخت
                                                فراوان جامعه و متخصصان را می
                                                طلبد، تا با نرم افزارها شناخت
                                                بیشتری را برای طراحان رایانه ای
                                                علی الخصوص طراحان خلاقی، و فرهنگ
                                                پیشرو در زبان فارسی ایجاد کرد،
                                                در این صورت می توان امید داشت که
                                                تمام و دشواری موجود در ارائه
                                                راهکارها، و شرایط سخت تایپ به
                                                پایان رسد و زمان مورد نیاز شامل
                                                حروفچینی دستاوردهای اصلی، و
                                                جوابگوی سوالات پیوسته اهل دنیای
                                                موجود طراحی اساسا مورد استفاده
                                                قرار گیرد.
                                            </div>
                                            <div className='modal-footer'>
                                                <button
                                                    type='button'
                                                    className='btn btn-dark'
                                                    data-bs-dismiss='modal'
                                                >
                                                    بستن
                                                </button>
                                                <button
                                                    type='button'
                                                    className='btn btn-primary'
                                                    data-bs-dismiss='modal'
                                                >
                                                    ذخیره تغییرات
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-sm-12 col-md-6 col-lg-3 mb-4'>
                        <div className='card'>
                            <div className='card-title bg-transparent p-3'>
                                مودال بسیار بزرگ
                            </div>

                            <div className='card-body m-auto'>
                                <button
                                    type='button'
                                    className='btn btn-primary'
                                    data-bs-toggle='modal'
                                    data-bs-target='#xlargeModal'
                                >
                                    امتحان کن
                                </button>

                                <div
                                    className='modal fade'
                                    id='xlargeModal'
                                    tabIndex='-1'
                                    aria-labelledby='xlargeModalLabel'
                                    aria-hidden='true'
                                >
                                    <div className='modal-dialog modal-xl'>
                                        <div className='modal-content'>
                                            <div className='modal-header'>
                                                <h5
                                                    className='modal-title'
                                                    id='xlargeModalLabel'
                                                >
                                                    مودال بسیار بزرگ
                                                </h5>
                                                <button
                                                    type='button'
                                                    className='btn-close'
                                                    data-bs-dismiss='modal'
                                                    aria-label='Close'
                                                />
                                            </div>
                                            <div className='modal-body'>
                                                لورم ایپسوم متن ساختگی با تولید
                                                سادگی نامفهوم از صنعت چاپ، و با
                                                استفاده از طراحان گرافیک است،
                                                چاپگرها و متون بلکه روزنامه و
                                                مجله در ستون و سطرآنچنان که لازم
                                                است، و برای شرایط فعلی تکنولوژی
                                                مورد نیاز، و کاربردهای متنوع با
                                                هدف بهبود ابزارهای کاربردی می
                                                باشد، کتابهای زیادی در شصت و سه
                                                درصد گذشته حال و آینده، شناخت
                                                فراوان جامعه و متخصصان را می
                                                طلبد، تا با نرم افزارها شناخت
                                                بیشتری را برای طراحان رایانه ای
                                                علی الخصوص طراحان خلاقی، و فرهنگ
                                                پیشرو در زبان فارسی ایجاد کرد،
                                                در این صورت می توان امید داشت که
                                                تمام و دشواری موجود در ارائه
                                                راهکارها، و شرایط سخت تایپ به
                                                پایان رسد و زمان مورد نیاز شامل
                                                حروفچینی دستاوردهای اصلی، و
                                                جوابگوی سوالات پیوسته اهل دنیای
                                                موجود طراحی اساسا مورد استفاده
                                                قرار گیرد.
                                            </div>
                                            <div className='modal-footer'>
                                                <button
                                                    type='button'
                                                    className='btn btn-dark'
                                                    data-bs-dismiss='modal'
                                                >
                                                    بستن
                                                </button>
                                                <button
                                                    type='button'
                                                    className='btn btn-primary'
                                                    data-bs-dismiss='modal'
                                                >
                                                    ذخیره تغییرات
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
